module.exports = __webpack_public_path__ + "assets/images/MultiDenomCash.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/MultiDenomCash.png
// module id = 1422
// module chunks = 1